import { httpApi } from "./axiosApi";

export const checkPlateNumberAvailability = (params) => httpApi.get(`/plate-numbers/check-availability/?${params}`).then(({ data }) => data)